import { styled } from '@ori-ui/mui';
import type { PropsWithChildren, VFC } from 'react';

import { TOP_NAV_HEIGHT, TOP_NAV_HEIGHT_MOBILE } from '../constants';

const TopAreaReservedSpaceBlock = styled('div')(({ theme }) => ({
  minHeight: TOP_NAV_HEIGHT,
  [theme.breakpoints.down('md')]: {
    minHeight: TOP_NAV_HEIGHT_MOBILE,
  },
}));

export const TopAreaBlock: VFC<PropsWithChildren<unknown>> = ({ children }) => (
  <TopAreaReservedSpaceBlock>{children}</TopAreaReservedSpaceBlock>
);
